export default "__VITE_PUBLIC_ASSET__c00fb648__"